// extracted by mini-css-extract-plugin
export default {"userMenu":"usermenu_userMenu__aMv+M","menuToggle":"usermenu_menuToggle__0iYlL","avatar":"usermenu_avatar__dBr7P"};